"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateVehicle = exports.deleteVehicle = exports.getVehicle = exports.addVehicle = exports.getVehicles = void 0;
const _ = require("lodash");
const getVehicles = async (supabase) => {
    const { data, error } = await supabase
        .from("vehicles")
        .select(`*`)
        .order("created_at", { ascending: false });
    if (!error) {
        return data.map((vehicle) => {
            return {
                ...vehicle,
                image: JSON.parse(vehicle.image),
            };
        });
    }
    return error;
};
exports.getVehicles = getVehicles;
const addVehicle = async (supabase, obj) => {
    const { data: { user }, } = await supabase.auth.getUser();
    if (user?.id) {
        obj.modified_by = user?.id;
        obj.created_by = user?.id;
    }
    const { data, error } = await supabase.from("vehicles").insert([obj]);
    if (!error)
        return data;
    return error;
};
exports.addVehicle = addVehicle;
const getVehicle = async (supabase, id) => {
    const { data, error } = await supabase
        .from("vehicles")
        .select(`*,
      modified_by_user:modified_by(id, first_name, last_name), 
      created_by_user:created_by(id, first_name, last_name)`)
        .eq("id", id)
        .single();
    if (!error)
        return data;
    return error;
};
exports.getVehicle = getVehicle;
const deleteVehicle = async (supabase, id) => {
    const { error } = await supabase.from("vehicles").delete().eq("id", id);
    return error;
};
exports.deleteVehicle = deleteVehicle;
const updateVehicle = async (supabase, obj) => {
    const updateObj = _.cloneDeep(obj);
    const { data: { user }, } = await supabase.auth.getUser();
    if (user?.id) {
        updateObj.modified_by = user?.id;
    }
    delete updateObj.created_by_user;
    delete updateObj.modified_by_user;
    const { data, error } = await supabase
        .from("vehicles")
        .update(updateObj)
        .eq("id", updateObj.id)
        .select(`*,
      modified_by_user:modified_by(id, first_name, last_name), 
      created_by_user:created_by(id, first_name, last_name)`)
        .single();
    if (!error)
        return data;
    return error;
};
exports.updateVehicle = updateVehicle;
